import { atom } from 'jotai';

const mobileColumnCountAtom = atom('2');

export default mobileColumnCountAtom;
